import React,{useEffect} from 'react'
import {useLocation } from 'react-router-dom';
import Banner from '../Components/MiddleSchoolComponents/Banner/Banner'
import School from '../Components/MiddleSchoolComponents/School/School'
import Testimonials from '../Components/MiddleSchoolComponents/TestimonialsSchool/TestimonialsSchool'
import Programme from '../Components/MiddleSchoolComponents/Programme/Programme'
import Choice from '../Components/MiddleSchoolComponents/Choice/Choice'
import Curriculum from '../Components/MiddleSchoolComponents/Curriculum/Curriculum'
import Faculties from '../Components/MiddleSchoolComponents/Faculties/Faculties'
import AdminssionPre from '../Components/MiddleSchoolComponents/AdmissionPre/AdmissionPre'
import Information from '../Components/MiddleSchoolComponents/Information/Information'
// import SuccessStory from '../Components/MiddleSchoolComponents/SuccessStory/SuccessStory'
import Gallery from '../Components/MiddleSchoolComponents/Gallery/Gallery'
import Transportation from '../Components/MiddleSchoolComponents/Transportation/Transportation'
import Apply from '../Components/MiddleSchoolComponents/Apply/Apply'
import OtherSections from '../Components/MiddleSchoolComponents/OtherSections/OtherSections'
import ReactGA from "react-ga4";

ReactGA.initialize("G-KE1087VQ84");

ReactGA.send({ hitType: "pageview", 
                page: window.location.pathname, });
const MiddleSchool = () => {
  const ScrollToTop = () => {
    const { pathname, state } = useLocation();
  
    useEffect(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
        if (state && state.targetSection) {
          const targetSection = document.querySelector(state.targetSection);
          if (targetSection) {
            targetSection.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }, 100); // Adding a slight delay to ensure scroll happens after the render
    }, [pathname, state]);
  
    return null;
  };
  return (
    <div>
           <ScrollToTop/>
      <Banner/>
      <School/>
      <Programme/>
      <Choice/>
      <Curriculum/>
      <Faculties/>
      <AdminssionPre/>
      <Information/>
      {/* <SuccessStory/> */}
      <Testimonials/>
      <Gallery/>
      <Transportation/>
      <Apply/>
      <OtherSections/>
      
    </div>
  )
}

export default MiddleSchool
